import React from 'react';
import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
import Environment from '@config/index';
// eslint-disable-next-line import/no-extraneous-dependencies
import type { AddressFormProps } from '@vestiaire/vc-address-form';

const AddressForm = dynamic<AddressFormProps>(
  () => import('@vestiaire/vc-address-form').then((mod) => mod.AddressForm),
  { ssr: false },
);
import styles from './account-addresses.module.scss';

const AccountAddresses: React.FC = () => {
  const { t } = useTranslation('account-settings');
  const wcConfig = {
    env: Environment.envName === 'teod' ? 'stage' : Environment.envName,
  };

  return (
    <div
      className={styles.accountAddresses}
      data-cy="account-addresses-section"
    >
      <h2 className={styles.accountAddresses__title}>{t('ACCOUNT_SETTINGS.MENU.ADDRESSES')}</h2>
      <AddressForm
        wcconfig={wcConfig}
        props={{
          context: 'account',
          displayScreen: 'inPage',
          modalOpen: false,
          nextStepDisplay: 'inModal',
          screen: 'book',
        }}
      />
    </div>
  );
};

export default AccountAddresses;
